<template>
    <div>
        <b-form-group label="FDO quotation"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="Set FDO reference to 'quotation'">
            <b-form-input v-model="value[0]"></b-form-input>
        </b-form-group>
        <b-form-group label="Sconti template"
                      label-size="sm"
                      :label-cols-sm="1"
                      :description="``">
            <b-form-select size="sm"
                           v-model="value[1]"
                           :options=templates>
            </b-form-select>
        </b-form-group>

    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";
import store from "../store";

export default {
    mixins: [valueCmp],
    computed: {
        templates() {
            return store.discountActivationTemplates.map(t => ({value: 'TDO.' + t.name, text: t.name}))
        }
    },
}
</script>

<style scoped>

</style>
